import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import ProgressBar from '@avalara/bat-apps-shared/client/components/ProgressBar';
import { SCol, SContainer, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Pages } from '../../../../../types/offers';
import { completePlanSelect } from '../../../lib/side-effects/offer-flow';
import { stepNames } from '../../../lib/side-effects/progress-bar';
import { selectState } from '../../../selectors';
import { getSelectedPlanName } from '../../../selectors/order';
import { setCurrentOfferPage } from '../../../store/offer';
import { selectPlan } from '../../../store/order';
import AvataxSandboxPlanSelect from './avatax-sandbox';
import ExemptionsPlanSelect from './exemptions';
import IossPlanSelect from './ioss';

import type {
  ExemptionsPlanClientDetails,
  IossPlanClientDetails,
  OfferPlanClientDetails,
} from '../../../../../types/offers';

const OfferPlanSelect = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    offer: { offerFlow, plans, pages },
  } = useSelector(selectState);

  const selectedPlanName = useSelector(getSelectedPlanName);

  useEffect(() => {
    dispatch(setCurrentOfferPage(Pages.Plans));
    dispatch(setProgressBarCurrentStep(stepNames.selectPlan));
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (plans.length === 0) return;
    if (plans.length === 1 && !pages.includes(Pages.Plans)) {
      dispatch(completePlanSelect(plans[0], { shouldReplaceHistory: true, history }));
    } else {
      dispatch(selectPlan({ planName: selectedPlanName, planSelectComplete: false }));
    }
  }, [plans]);

  const renderPlanSelect = () => {
    switch (offerFlow) {
      case 'avatax-sandbox':
        return <AvataxSandboxPlanSelect plans={plans} />;
      case 'exemptions':
        return <ExemptionsPlanSelect plans={plans as Array<OfferPlanClientDetails & ExemptionsPlanClientDetails>} />;
      case 'ioss':
        return <IossPlanSelect plans={plans as Array<OfferPlanClientDetails & IossPlanClientDetails>} />;
      default:
        return null;
    }
  };

  return (
    // biome-ignore lint/a11y/useSemanticElements: using Skylab's component
    <SContainer role='main'>
      <SRow className='pad-top-sm'>
        <SCol>
          <ProgressBar />
        </SCol>
      </SRow>

      {renderPlanSelect()}
    </SContainer>
  );
};

export default OfferPlanSelect;
